module.exports = __webpack_public_path__ + "img/budget.9493613f.png";